import React from "react";
import { Modal as ModalReact } from "react-bootstrap";

import './Modal.scss';

export default function Modal(props) {
    const { children, title, isVisible, setIsVisible, setSize } = props;

    return (
        <>
            <ModalReact
                centered
                show={isVisible}
                onHide={() => setIsVisible(false)}
                size={setSize}
                className={setSize === "xl" ? "fullscreen-modal" : ""}
            >
                <ModalReact.Header closeButton>
                    <ModalReact.Title id="example-custom-modal-styling-title">
                        {title}
                    </ModalReact.Title>
                </ModalReact.Header>
                <ModalReact.Body>
                    {children}
                </ModalReact.Body>
            </ModalReact>
        </>
    )

}